(function ($) {
  $(function () {
    if (!$('#contact').length)
      $("a[href='#contact']").attr('href', `${ThemeJS.Variables.Home}#contact`);
  });
})(jQuery);
